import { IStorage } from './IStorage';
import { backbone } from '@visikon/backbone';

export const GetStorage = (): IStorage => {
  return backbone.store.getState().storageApi;
};
